import React from "react";
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton
} from "@chakra-ui/react";
import { Callback } from "types";

interface Props {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClose: Callback;
}

const Modal: React.FC<Props> = ({
  children,
  title,
  isOpen,
  onClose
}: Props) => (
  <ChakraModal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
    <ModalOverlay />
    <ModalContent
      bg="gray.900"
      rounded="xl"
      borderColor="whiteAlpha.100"
      borderWidth="2px"
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalCloseButton />
      <ModalBody pt={4} pb={8}>
        {children}
      </ModalBody>
    </ModalContent>
  </ChakraModal>
);

export default Modal;
